import { render, staticRenderFns } from "./ApproveUserCallout.vue?vue&type=template&id=761f0239"
import script from "./ApproveUserCallout.vue?vue&type=script&lang=js"
export * from "./ApproveUserCallout.vue?vue&type=script&lang=js"
import style0 from "./ApproveUserCallout.vue?vue&type=style&index=0&id=761f0239&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports